import React from "react";
import PropTypes from "prop-types";

function GridArea({ row, column, columnSpan, className, children, rowSpan }) {
    const style = {
        gridRow: rowSpan ? `${row} / ${rowSpan}` : `${row}`,
        gridColumn: `${column} / span ${columnSpan || 1}`,
    };

    return (
        <div className={className} style={style}>
            {children}
        </div>
    );
}

GridArea.propTypes = {
    row: PropTypes.number.isRequired,
    column: PropTypes.number.isRequired,
    columnSpan: PropTypes.number,
    rowSpan: PropTypes.number,
    className: PropTypes.string,
};

export default GridArea;
